import {
  submitFedexMfaBackupInputSchema,
  submitFedexMfaBackupOutputSchema,
} from "@redotech/redo-fulfillment-carrier-account-common/fedex-customer-registration";

export const submitFedexMfaBackup = {
  name: "submitFedexMfaBackup" as const,
  input: submitFedexMfaBackupInputSchema,
  output: submitFedexMfaBackupOutputSchema,
};
